import { useDataValue } from 'Simple/Data.js'
/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let location_id = useDataValue({
    context: 'selected',
    viewPath: props.viewPath,
    path: 'id',
  })
  return {
    variables: { location_id },
    pause: !location_id,
  }
}
